'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import GoogleTagDataLayer from './GoogleTagDataLayer';

export default function GoogleAnalyticsClient() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const queryParams: Record<string, string> = {};
  if (searchParams) {
    searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });
  }

  useEffect(() => {
    if (!window.dataLayer) return;
    const url = pathname + (searchParams?.toString() ? `?${searchParams}` : '');
    window.dataLayer.push({ event: 'pageview', page: url });
  }, [pathname, searchParams]);

  return (
    <>
      <GoogleTagDataLayer key="gtm-data-tag" />
    </>
  );
}
